var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	2331: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,17,3,0], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 7580))))))),
	2391: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [1,17,3,0], () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(/*! @angular/animations */ 7172))))))),
	8701: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,17,3,0], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(/*! @angular/common */ 316))))))),
	4866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 845))))))),
	2778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 8219))))))),
	3312: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [1,17,3,10], () => (__webpack_require__.e(433).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	3648: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [1,17,3,10], () => (__webpack_require__.e(6787).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	5556: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [1,17,3,10], () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 3680))))))),
	6066: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", false, [1,17,3,10], () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 9975))))))),
	6672: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [1,17,3,10], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 4879))))))),
	7636: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [1,17,3,10], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 7699))))))),
	9394: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", false, [1,17,3,10], () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 7989))))))),
	7619: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,17,3,0], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 5689))))))),
	4251: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [1,17,3,0], () => (__webpack_require__.e(3036).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 655))))))),
	9022: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,17,3,0], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 436))))))),
	4411: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,17,3,0], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 6443))))))),
	2057: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,17,3,0], () => (__webpack_require__.e(5072).then(() => (() => (__webpack_require__(/*! @angular/router */ 5072))))))),
	3022: () => (loadSingletonVersion("default", "@predigle/auth-ngx-predigle", false, [1,1,0,7], () => (__webpack_require__.e(5984).then(() => (() => (__webpack_require__(/*! @predigle/auth-ngx-predigle */ 3603))))))),
	4453: () => (loadStrictSingletonVersion("default", "@angular/platform-browser/animations", false, [1,17,3,0], () => (__webpack_require__.e(6216).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 3835))))))),
	8519: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,17,3,0], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(/*! @angular/forms */ 4456))))))),
	8792: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [1,17,3,10], () => (__webpack_require__.e(1570).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 1570)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"436": [
		2331,
		4411,
		8701
	],
	"655": [
		2331,
		2391
	],
	"1342": [
		2778,
		4411,
		4866,
		8519,
		8792
	],
	"1570": [
		3312,
		3648,
		5556,
		6066,
		6672,
		7636
	],
	"2075": [
		2331,
		2778,
		4866,
		8701
	],
	"2284": [
		2778,
		4411,
		4866,
		8519,
		8792
	],
	"2356": [
		9394
	],
	"2691": [
		2331,
		2778,
		4866,
		8701,
		9022
	],
	"2814": [
		2331
	],
	"3036": [
		2391
	],
	"3603": [
		2331,
		2778,
		4411,
		4866,
		8701
	],
	"3680": [
		2331,
		8701
	],
	"3835": [
		2331,
		4251,
		8701,
		9022
	],
	"4791": [
		8701
	],
	"5020": [
		2057,
		2331,
		2391,
		2778,
		3022,
		4411,
		4453,
		4866,
		8701,
		9022
	],
	"5072": [
		2778,
		4866,
		9022
	],
	"6216": [
		4251
	],
	"6443": [
		2331,
		2778,
		4866,
		8701
	],
	"7172": [
		2331,
		8701
	],
	"7580": [
		2778,
		4866,
		7619
	],
	"7699": [
		2331,
		8701
	],
	"7935": [
		2331
	],
	"7989": [
		2331,
		4866
	],
	"8055": [
		4411
	],
	"8100": [
		2778,
		4411,
		4866,
		8519,
		8792
	],
	"8824": [
		2778,
		4866
	],
	"9168": [
		2331,
		8701
	],
	"9189": [
		2331,
		2778,
		3312,
		3648,
		4866,
		5556,
		6066,
		6672,
		7636,
		8701
	],
	"9975": [
		2331,
		2778,
		3312,
		4866,
		5556,
		7636,
		8701,
		9394
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}